import Phaser from 'phaser';
import { fetchMe } from '../network/api.js';
import { clearSession, getToken, isApproved } from '../network/session.js';
import { transitionTo } from '../ui/transition.js';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    void this.route();
  }

  private async route(): Promise<void> {
    if (!getToken()) {
      transitionTo(this, 'Login');
      return;
    }
    // Re-validate the token and refresh approval status before routing.
    try {
      const user = await fetchMe();
      transitionTo(this, isApproved(user) ? 'Lobby' : 'Pending');
    } catch {
      // Invalid/expired token — start over.
      clearSession();
      transitionTo(this, 'Login');
    }
  }
}
